/* eslint-disable no-undef */
export default {
	name: "driver-vehicle-modal",
	props: ["heading", "modalId", "showModal", "driverId"],
	emits: ["okClicked"],
	data() {
		return {
			// driverVehicle: {},
			driverVehicles: [],
			vehicleHeadings: [
				{
					text: "Make",
					field: "make"
				},
				{
					text: "Model",
					field: "model"
				},
				{
					text: "Year",
					field: "year"
				},
				{
					text: "Vehicle Registration",
					field: "vehicleRegistration"
				},
				{
					text: "Trailer Registration",
					field: "trailerRegistration"
				},
				{
					text: "Fleet Number",
					field: "fleetNumber"
				},
				{
					text: "Capacity (Litres)",
					field: "capacity"
				},
				{
					text: "Default Driver",
					field: "defaultDriver"
				},
				{
					text: "Default Driver ID",
					field: "defaultDriverId"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getDriverVehicles(){
			this.loading = true;
			let request = {
				driverId: this.driverId
			};
			systemService.getVehiclesByDefaultDriverId(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.driverVehicles = successResponse.data.result;
						this.driverVehicles = dataTableHelper.castFieldValues(this.driverVehicles);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		// getDriverVehicle() {
		// 	this.driverVehicle = {
		// 		driverId: this.driverId,
		// 		vehicleId: 1,
		// 		vehicleName: "Ford",
		// 		vehicleRegistrationNumber: "CA 123 456",
		// 		vehicleMake: "Ford",
		// 		vehicleModel: "Fiesta",
		// 		vehicleYear: "2015",
		// 		fleetNumber: "123456",
		// 		capacity: "100",
		// 	};
		// },
		clearMessageAlerts(){
			this.$emit("okClicked", true);
		},
		onModalCloseClick() {
			this.$emit("okClicked", true);
		}
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		driverId:{
			handler: function () {
				if(this.driverId) {
					this.getDriverVehicles();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
